export class LiveDetails {
    constructor(
        public vendorNegotiation?: vendorNegotiation[],
        public negotiationTotalAmount?: number,
        public rfpItemType?: String

    ) {
        this.vendorNegotiation = vendorNegotiation;
        this.negotiationTotalAmount = negotiationTotalAmount;
        this.rfpItemType =  rfpItemType
    }
}
interface vendorNegotiation {
    negotiation_id: number,
    rfpId: number,
    rfpCode: string,
    negotiationCode: string,
    itemPrice: number,
    itemOfferPrice: number,
    priceIncludingCharges:number,
    negotiationDescription:string,
    itemId: number,
    itemName: string,
    service_id?: number,
    serviceName?: string,
    vendor_id: number,
    vendorName: string,
    assetClass_id: number,
    assetClassName: string,
    assetCategories_id: number,
    assetCategoryName: string,
    quantity: number,
    companyBranchName: string,
    companyBranchCode: string,
    createdBy: string,
    updatedBy: string,
    comments: string,
    Additional_charges: number,
    CGST: number,
    SGST: number,
    IGST: number,
    VAT?: any,
    isVAT?: boolean,
    taxType?: string,
    currency_code?: string,
    vendor_type?: string,
    gst_type?: string,
    calculatedSum:number,
    rfpItemType: string,
    [key: string]: any
}
